/**
 * Collection Filters — Client-side filtering, sorting, and category tabs
 *
 * Uses event delegation on the collection grid container. All filtering
 * operates on the DOM directly (no page reload) so the experience feels
 * instant. Product cards carry data attributes for type, availability,
 * price, and creation date that the filters read at runtime.
 */
(function () {
  'use strict';

  const SELECTORS = {
    root: '[data-collection-grid]',
    card: '[data-product-card]',
    categoryTab: '[data-category-tab]',
    filterPill: '[data-filter-pill]',
    sortSelect: '[data-sort-select]',
    resultsCount: '[data-results-count]',
    productGrid: '[data-product-grid]',
  };

  /** State ------------------------------------------------------------- */
  let activeCategory = 'all';
  let activeFilter = 'all';

  /** Helpers ----------------------------------------------------------- */

  function getCards() {
    const root = document.querySelector(SELECTORS.root);
    if (!root) return [];
    return Array.from(root.querySelectorAll(SELECTORS.card));
  }

  function matchesCategory(card) {
    if (activeCategory === 'all') return true;
    return card.dataset.productType === activeCategory;
  }

  function matchesFilter(card) {
    if (activeFilter === 'all') return true;
    if (activeFilter === 'in-stock') {
      return card.dataset.available === 'true';
    }
    if (activeFilter === 'under-20') {
      return parseFloat(card.dataset.price) < 20;
    }
    return true;
  }

  function applyVisibility() {
    const cards = getCards();
    let visibleCount = 0;
    let inStockCount = 0;

    cards.forEach(function (card) {
      const show = matchesCategory(card) && matchesFilter(card);
      card.style.display = show ? '' : 'none';
      if (show) {
        visibleCount++;
        if (card.dataset.available === 'true') inStockCount++;
      }
    });

    updateResultsCount(visibleCount, inStockCount);
  }

  function updateResultsCount(total, inStock) {
    const el = document.querySelector(SELECTORS.resultsCount);
    if (!el) return;

    const itemWord = total === 1 ? 'item' : 'items';
    el.textContent =
      'showing ' + total + ' ' + itemWord + ' \u00B7 ' + inStock + ' in stock';
  }

  function setActiveClass(group, activeEl) {
    document.querySelectorAll(group).forEach(function (el) {
      el.classList.remove('active');
    });
    activeEl.classList.add('active');
  }

  /** Sort --------------------------------------------------------------- */

  function sortCards(mode) {
    const grid = document.querySelector(SELECTORS.productGrid);
    if (!grid) return;

    const cards = getCards();

    cards.sort(function (a, b) {
      switch (mode) {
        case 'price-asc':
          return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        case 'price-desc':
          return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        case 'newest':
          return (
            new Date(b.dataset.createdAt).getTime() -
            new Date(a.dataset.createdAt).getTime()
          );
        default:
          // "featured" — restore original order via data-position
          return (
            parseInt(a.dataset.position, 10) -
            parseInt(b.dataset.position, 10)
          );
      }
    });

    // Re-append in sorted order (moves DOM nodes without cloning)
    cards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  /** Event Delegation -------------------------------------------------- */

  function handleClick(event) {
    // Category tabs
    var tab = event.target.closest(SELECTORS.categoryTab);
    if (tab) {
      activeCategory = tab.dataset.categoryTab;
      setActiveClass(SELECTORS.categoryTab, tab);
      applyVisibility();
      return;
    }

    // Filter pills
    var pill = event.target.closest(SELECTORS.filterPill);
    if (pill) {
      activeFilter = pill.dataset.filterPill;
      setActiveClass(SELECTORS.filterPill, pill);
      applyVisibility();
    }
  }

  function handleChange(event) {
    var select = event.target.closest(SELECTORS.sortSelect);
    if (select) {
      sortCards(select.value);
      applyVisibility();
    }
  }

  /** Init -------------------------------------------------------------- */

  function init() {
    var root = document.querySelector(SELECTORS.root);
    if (!root) return;

    root.addEventListener('click', handleClick);
    root.addEventListener('change', handleChange);

    // Set initial results count
    applyVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
